import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import qs from 'query-string';

import { Processing } from '../components/processing';
import { PATHS } from '../configs';
import client from '../services/client';
import { useInvoice } from '../services/use-invoice';
import { useAppContext } from '../stores/app-context';
import { useDedupedCallback } from '../utils/use-deduped-callback';

import type { PaymentMethodType } from '@autopass-web/types';

export const AuthCreditCard = () => {
  const { invoiceId } = useParams();
  const navigate = useNavigate();
  const isInvoiceIdValid = typeof invoiceId === 'string';

  const { onToastError } = useAppContext();

  const { invoice, refetch } = useInvoice(
    { invoiceId },
    {
      enabled: isInvoiceIdValid,
    },
  );

  const searchData = qs.parse(window.location.search);
  const hashData = qs.parse(window.location.hash);
  const captureMethod = invoice.capture_method;

  const { serviceTransactionId } = searchData as {
    serviceTransactionId: string;
  };

  const { token, merchant_transaction_id } = hashData as {
    custom_data: unknown;
    merchant_transaction_id: string;
    source: PaymentMethodType;
    title: string;
    token: string;
  };

  const confirmCreditCardTransaction = useDedupedCallback(async () => {
    try {
      if (captureMethod === 'manual') {
        await client.confirmAuthorizedTransaction({
          merchantTransactionId: merchant_transaction_id,
          token,
          serviceTransactionId,
          invoiceId,
        });
      } else {
        await client.confirmDirectPaymentTransaction({
          merchantTransactionId: merchant_transaction_id,
          token,
          serviceTransactionId,
          invoiceId,
        });
      }
    } catch {
      onToastError('付款失敗，請重新付款');

      navigate(PATHS.INVOICES(invoiceId)['']);
    } finally {
      refetch();
    }
  }, [
    merchant_transaction_id,
    token,
    serviceTransactionId,
    invoiceId,
    invoice,
  ]);

  useEffect(() => {
    if (invoice.payment_state === 'paid') {
      return;
    }

    // prevent execute the identical transaction twice
    confirmCreditCardTransaction();
  }, [confirmCreditCardTransaction, invoice.payment_state]);
  return <Processing />;
};
